import React, { memo } from 'react';
import { motion } from 'framer-motion';

interface SkeletonLoaderProps {
  className?: string;
  lines?: number;
}

interface SkeletonItemProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const SkeletonShimmer: React.FC = memo(() => (
  <motion.div
    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/80 dark:via-dark-600 to-transparent pointer-events-none"
    animate={{
      x: ['-100%', '100%'],
    }}
    transition={{
      repeat: Infinity,
      duration: 1.5,
      ease: 'easeInOut',
    }}
  />
));
SkeletonShimmer.displayName = 'SkeletonShimmer';

export const SkeletonItem: React.FC<SkeletonItemProps> = memo(({
  className = '',
  style,
  children,
}) => (
  <div className={`relative overflow-hidden bg-neutral-200 dark:bg-dark-200 ${className}`} style={style}>
    <SkeletonShimmer />
    {children}
  </div>
));
SkeletonItem.displayName = 'SkeletonItem';

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = memo(({ 
  className = '', 
  lines = 1 
}) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <SkeletonItem key={index} className="rounded-lg h-4" />
      ))}
    </div>
  );
});
SkeletonLoader.displayName = 'SkeletonLoader';

export default SkeletonLoader;